import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { getSelectedPbiReportUrl } from 'src/app/core/helpers/power-bi-reports.helper';
import {
  getReportsForDisplay,
  GroupedReports
} from 'src/app/core/helpers/report-display-order.helper';
import { PowerBiReportViewerService } from 'src/app/core/services/report-viewer.service';
import { LocatorLibraryData } from 'src/app/locator/models/locator-library-data';
import { LocatorPowerBiReportingInfo } from 'src/app/locator/models/locator-power-bi-reporting-info';
import { LocatorShape } from 'src/app/locator/models/locator-shape';
import { LocatorReportTypes } from 'src/app/locator/types/locator-report.types';
import {
  applyFilter,
  SearchAndSortValues
} from 'src/app/shared/utils/list-utils';

@Component({
  selector: 'atlas-locator-reporting-form',
  styleUrls: ['locator-reporting-form.component.less'],
  templateUrl: 'locator-reporting-form.component.html',
  standalone: false
})
export class LocatorReportingFormComponent implements OnInit {
  private _pbiReports: LocatorPowerBiReportingInfo[] = [];
  @Input()
  set pbiReports(newValue: LocatorPowerBiReportingInfo[]) {
    this._pbiReports = [...newValue];
    this.dataSource = [...newValue];
    this.groupReports(this.dataSource);
  }
  get pbiReports(): LocatorPowerBiReportingInfo[] {
    return this._pbiReports;
  }

  @Input() selectedShapes: LocatorShape[];
  @Input() selectedLocationData: LocatorLibraryData;

  locatorReportingForm: UntypedFormGroup;
  dataSource: LocatorPowerBiReportingInfo[] = [];
  groupedDataSource: GroupedReports<LocatorPowerBiReportingInfo>[] = [];

  selectedReport: LocatorPowerBiReportingInfo | null = null;
  selectedPbiReportUrl = '';

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private powerBiReportViewerService: PowerBiReportViewerService
  ) {}

  ngOnInit(): void {
    const initialValue: SearchAndSortValues = {
      filter: ''
    } as SearchAndSortValues;
    this.locatorReportingForm = this.createForm(initialValue);
  }

  createForm(initialLibraryValue: SearchAndSortValues) {
    return this.fb.group({
      filter: [initialLibraryValue.filter]
    });
  }

  onFilterChanged(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource = applyFilter(filterValue, this._pbiReports);
    this.groupReports(this.dataSource);
  }

  onSelectionChange(report: LocatorPowerBiReportingInfo) {
    this.selectedPbiReportUrl = '';
    this.selectedReport = report;

    const selectedShapeIds = this.selectedShapes.map((shape) => shape.id);
    if (this.selectedReport?.reportType !== LocatorReportTypes.Summary_Stats) {
      getSelectedPbiReportUrl(
        this.powerBiReportViewerService,
        this.router,
        this.selectedReport?.workspaceId!,
        this.selectedReport?.powerBiReportId!,
        this.selectedReport?.disableExport!,
        [this.selectedLocationData.libraryId, selectedShapeIds]
      ).subscribe((pbiReportUrl) => (this.selectedPbiReportUrl = pbiReportUrl));
    }
  }

  private groupReports(reports: LocatorPowerBiReportingInfo[]): void {
    this.groupedDataSource = getReportsForDisplay(reports);
  }
}
